import { io } from "socket.io-client";
import { getApiBaseUrl } from "../utils/baseUrl";

const API_URL = getApiBaseUrl();

console.log(`🌐 Connecting to Socket.IO backend at: ${API_URL}`);

const socket = io(API_URL, {
  // Start with HTTP polling so CRA/Nginx can establish the Engine.IO session
  // reliably, then let Socket.IO upgrade to WebSocket when the proxy supports
  // it. Starting with WebSocket caused a 10-second timeout on localhost:3000.
  transports: ["polling", "websocket"],
  withCredentials: true,
  reconnectionAttempts: 5,
  timeout: 10000,
  autoConnect: false,
});

// Events for debugging and clarity
socket.on("connect", () => {
  console.log(`✅ Socket.IO connected, ID: ${socket.id}`);
});

socket.on("connect_error", (err) => {
  console.error("❌ Connection Error:", err.message || err);
});

socket.on("disconnect", (reason) => {
  console.warn(`⚠️ Disconnected: ${reason}`);
});

socket.io.on("reconnect_attempt", () => {
  console.info("🔄 Trying to reconnect...");
});

export const connectSocketWithToken = (token) => {
  const cleanToken = String(token || "").trim();
  if (!cleanToken) return;
  socket.auth = { token: cleanToken };
  if (!socket.connected) socket.connect();
};

export default socket;
